module.exports = __webpack_public_path__ + "img/share-01.de31863c.svg";